import { currencyToNumber } from 'vqp-common';

const sortByOrder = (a, b) => a.Ordem - b.Ordem;

export const mapFetchProductsCategoriesResponse = (response) => {
  const sortedCategories = response['Categorias'].sort(sortByOrder);
  return sortedCategories.map((cat) => ({
    id: cat['Id'],
    name: cat['NomeCategoria'],
    order: cat['Ordem'],
    status: cat['Status'],
    products: cat['Produtos'].sort(sortByOrder).map((product) => ({
      id: product['Id'],
      code: product['Codigo'],
      order: product['Ordem'],
      name: product['Nome'],
      status: product['Status'],
      price: product['Valor'],
      priceDelivery: product['ValorDelivery']
    }))
  }));
};

export const mapEditCategoryRequest = (data) => {
  if (data.storeId) {
    return {
      NomeCategoria: data.name,
      EstabelecimentoId: data.storeId
    };
  }
  return {
    NomeCategoria: data.name
  };
};

export const mapUpdateCategoriesOrder = ({ categories, products, storeId }) => {
  return {
    Categorias: categories.map((cat) => ({
      Id: cat.id,
      Ordem: cat.order
    })),
    Produtos: products.map((prod) => ({
      Id: prod.id,
      Ordem: prod.order
    })),
    EstabelecimentoId: storeId
  };
};

const mapDetailItemResponse = (item) => {
  return {
    id: item.Id,
    name: item.Nome,
    code: item.Codigo,
    order: item.Ordem,
    price: item.Valor,
    delivery: item.Delivery,
    deliveryPrice: item.ValorDelivery,
    description: item.Descricao,
    counter: !!item.Balcao
  };
};

const mapDetailGroupResponse = (detail) => {
  return {
    id: detail.Id,
    name: detail.Nome,
    min: detail.Minimo,
    max: detail.Maximo,
    counter: detail.Balcao,
    delivery: detail.Delivery,
    isCheckbox: detail.Checkbox,
    calcType: detail.TipoCalculoCustomizacao - 1,
    order: detail.Ordem,
    description: detail.Descricao,
    items: detail.Detalhes.map(mapDetailItemResponse)
  };
};

export const mapFetchProductResponse = (response) => {
  const product = response.Produto;
  return {
    id: product.Id,
    code: product.Codigo,
    name: product.NomeProduto,
    printName: product.NomeImpressao,
    printLocation: product.LocalImpressao,
    price: product.Valor,
    deliveryPrice: product.ValorDelivery,
    description: product.Descricao,
    mix: product.ProdutoMix,
    counter: product.Balcao,
    delivery: product.Delivery,
    imageUrl: product.ImagemUrl,
    order: product.Ordem,
    promo: product.ValorPromocional,
    displayFrom: product.ExibirAPartirDe,
    rewardValue: product.ValorPremio,
    details: product.GruposDetalhes.map(mapDetailGroupResponse),
    hasRestrictions: product.RestricaoProduto,
    restrictions: product.RestricaoProdutos.map((restriction) => ({
      day: restriction.Dia,
      fromTime: restriction.HoraInicio,
      toTime: restriction.HoraFinal
    }))
  };
};

export const mapProductFormToApi = (data, storeId) => {
  const rewardImageFilename = data && data.rewardImage && data.rewardImage.name;
  const rewardImageFilenameArray = rewardImageFilename && rewardImageFilename.split('.');
  const rewardImageUrl = `${rewardImageFilenameArray && rewardImageFilenameArray.length && rewardImageFilenameArray[0]
    }(premio).${rewardImageFilenameArray && rewardImageFilenameArray.length && rewardImageFilenameArray[1]
    }`;

  const formData = new FormData();
  const request = {
    Id: data.id,
    CategoriaId: data.category,
    Codigo: data.code,
    NomeProduto: data.name,
    NomeImpressao: data.printNameEquals ? data.name : data.printName,
    LocalImpressao: data.printLocation,
    Valor: currencyToNumber(data.price),
    ValorDelivery: data.deliveryPriceEquals
      ? currencyToNumber(data.price)
      : currencyToNumber(data.deliveryValue),
    EstabelecimentoId: storeId,
    Descricao: data.description,
    ProdutoMix: data.mix,
    Balcao: data.counter,
    Delivery: data.delivery,
    ImagemUrl: data.imageUrl,
    DeletarImagem: data.deleteImage,
    ImagemPremio: rewardImageUrl,
    DeletarImagemPremio: data.deleteRewardImage,
    Ordem: data.order,
    ValorPromocional: data.promo ? currencyToNumber(data.promo) : undefined,
    ExibirAPartirDe: data.displayFrom,
    ValorPremio: data.rewardValue,
    tipoPlataformaDisponivelId: 1,
    GruposDetalhes:
      data.details &&
      data.details.map((detail) => ({
        Id: detail.id,
        Nome: detail.name,
        Descricao: detail.description,
        Minimo: detail.min,
        Maximo: detail.max,
        CheckBox: detail.isCheckbox,
        Ordem: detail.order,
        Balcao: detail.counter,
        Delivery: detail.delivery,
        tipoPlataformaDisponivelId: 1,
        TipoCalculoCustomizacao: detail.calc >= 0 ? detail.calc + 1 : detail.calcType + 1,
        Detalhes:
          detail.items &&
          detail.items.map((item, index) => ({
            Id: item.id,
            Nome: item.name,
            Codigo: item.code,
            Balcao: item.counter,
            Delivery: item.delivery,
            Valor: currencyToNumber(item.price),
            ValorDelivery: item.deliveryPriceEquals
              ? currencyToNumber(item.price)
              : currencyToNumber(item.deliveryPrice),
            Ordem: index + 1,
            Descricao: item.description,
            tipoPlataformaDisponivelId: 1
          }))
      })),
    RestricaoProduto: data.hasRestrictions,
    RestricoesProduto:
      data.restrictions &&
      data.restrictions.map((restriction) => ({
        Dia: restriction.day,
        HorarioInicio: restriction.fromTime,
        HorarioFim: restriction.toTime
      }))
  };

  formData.set('request', JSON.stringify(request));
  if (data.image) {
    formData.append('image', data.image);
  }
  return formData;
};

export const mapFetchDetailGroupsResponse = (response) => {
  return response.GruposDetalhes.map(mapDetailGroupResponse);
};

export const mapFetchDetailItemsResponse = (response) => {
  return response.Detalhes.map(mapDetailItemResponse);
};
